import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import { LocationService } from './services/LocationService';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import PushService from './services/PushService';

// Global error handler for Monaco cancellation errors
window.addEventListener('unhandledrejection', (event) => {
  // Handle Monaco editor cancellation errors gracefully
  if (event.reason && event.reason.message && event.reason.message.includes('Canceled')) {
    console.log('🔄 Monaco operation cancelled gracefully (global handler)');
    event.preventDefault(); // Prevent the error from being logged as uncaught
  }
});

// Global error handler for synchronous Monaco errors
window.addEventListener('error', (event) => {
  // Handle Monaco editor cancellation errors gracefully
  if (event.error && event.error.message && event.error.message.includes('Canceled')) {
    console.log('🔄 Monaco operation cancelled gracefully (global sync handler)');
    event.preventDefault(); // Prevent the error from being logged as uncaught
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily disabled StrictMode to fix input lag
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
); 

// Optional: warm up native permissions prompts gracefully after mount
try {
  if (Capacitor?.isNativePlatform?.()) {
    // Do not force permission; just a soft check to speed up first location use
    LocationService.requestPermissions().catch(() => {});
    // Initialize push in background (logs token if granted)
    PushService.init().catch(() => {});
    
    // Handle Android hardware back button
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        // At root of navigation - minimize app instead of exiting
        CapacitorApp.minimizeApp();
      }
    });
  }
} catch (_) {}